import ColorPickerInput from './color-picker';

export { ColorPickerInput };
